// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../adm-saas/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".login-modal{background:#fff;min-width:300px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
